import { BaseRecord } from './BaseRecord';

export class CompanyYear extends BaseRecord {
  public year: number;
  constructor() {
    super();
    this.year = 0;
  }
}
